import React from 'react'
import {Route, Switch} from "react-router-dom";
import Login from "../src/pages/login"
// import Home from "../src/pages/home"
// import Release from "../src/pages/release"
const Routes = () =>{

    return(
        
        <Switch>
            {/* <Route path="/release" exact component={Release} />
            <Route path="/" component={Home} /> */}
            <Route path="/" component={Login} />
        </Switch>
    )
}

export default Routes